<template>
  <div>
    <user-detail-title
      first-bread="标签管理"
      second-bread="产品所属分类"
      third-bread="产品所属分类查看"
      first-url="/user/sign"
      second-url="/user/classify"
      title-name="产品所属分类查看"
    >
    </user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px" v-if="LookData">

        <el-form-item label="名称">
          <el-input :placeholder="LookData.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="logo">
          <el-image class="item-image" :src="'http://'+LookData.classifyLogoUrl" alt=""></el-image>
        </el-form-item>
        <el-form-item label="所属分类">
          <el-input :placeholder="LookData.superClassifyName" disabled></el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-input :placeholder="LookData.createTime" disabled></el-input>
        </el-form-item>
        <el-form-item label="更新时间">
          <el-input :placeholder="LookData.updateTime" disabled></el-input>
        </el-form-item>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "ProductClassifyLook",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetLookData(id){
        this.$axios.get('/api/productClassify/getById',{params:{
            id:id
          }}).then(res=>{
          this.LookData=res.data.data
        })
      }
    }
  }
</script>

<style scoped>

</style>